import React from 'react'
import moment from 'moment'

export default class PatientData extends React.Component {
  render () {
    var identificacion = this.props.data.patientData.tipoDocumento + ' ' + this.props.data.patientData.numeroDocumento
    var nombrePaciente = this.props.data.patientData.nombrecompleto
    var edadPaciente = this.props.data.patientAge + ' años'
    var genero = (this.props.data.patientData.genero === 'f') ? 'Femenino' : 'Masculino'
    var entidad = this.props.data.patientEPS
    var fechaIngreso = moment(this.props.data.patientData.timestamp, 'x').format('DD/MM/YYYY')

    return (
      <div className='patien-basic-information'>
        <div className='basic-data-report-container'>
          <label><span className='data-tag'>Nombre: </span> {nombrePaciente}</label>
        </div>
        <div className='basic-data-report-container'>
          <label><span className='data-tag'>Identificación: </span> {identificacion}</label>
        </div>
        <div className='basic-data-report-container'>
          <label><span className='data-tag'>Género: </span> {genero}</label>
        </div>
        <div className='basic-data-report-container'>
          <label><span className='data-tag'>Edad: </span> {edadPaciente}</label>
        </div>
        <div className='basic-data-report-container'>
          <label><span className='data-tag'>Fecha de ingreso: </span> {fechaIngreso}</label>
        </div>
        <div className='basic-data-report-container'>
          <label><span className='data-tag'>Entidad: </span> {entidad}</label>
        </div>
      </div>
    )
  }
}

PatientData.propTypes = {
  data: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDiabetes/PatientData.js